// localStorage flag for controlling display of interstitial ("about") page
export const SHOW_DEV_INTERSTITIAL = 'SHOW_DEV_INTERSTITIAL';

export const SIGN_OUT_REASONS = {
  SIGNED_OUT: 'sign-out',
  INACTIVE: 'inactive',
  MAX_SESSION: 'session',
};

export const AsyncActionState = {
  Idle: 'idle',
  Loading: 'loading',
  Failed: 'failed',
  Success: 'success',
};
// This seems to be the closest to identifying User's cancel from WebAuth dialog box
export const WEBAUTHN_CANCEL_MESSAGE = 'The operation either timed out or was not allowed';
